import { render, staticRenderFns } from "./options-group.vue?vue&type=template&id=2d1107f5&"
import script from "./options-group.vue?vue&type=script&lang=js&"
export * from "./options-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1107f5')) {
      api.createRecord('2d1107f5', component.options)
    } else {
      api.reload('2d1107f5', component.options)
    }
    module.hot.accept("./options-group.vue?vue&type=template&id=2d1107f5&", function () {
      api.rerender('2d1107f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/select/src/options-group.vue"
export default component.exports